'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var internals = {};

// eslint-disable-next-line hapi/hapi-scope-start
module.exports = function (superclass) {
    return function (_superclass) {
        _inherits(_class, _superclass);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, Object.getPrototypeOf(_class).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'strangeForm',


            // Must be called in constructor
            value: function strangeForm(_ref) {
                var act = _ref.act;
                var get = _ref.get;
                var fields = _ref.fields;
                var getFormValue = _ref.getFormValue;


                fields = fields || [];
                getFormValue = getFormValue || internals.defaultGetFormValue;

                this._sfOpts = { act: act, get: get, getFormValue: getFormValue };

                // For quick field-exists lookups

                this._sfOpts.fieldsMap = fields.reduce(function (collect, field) {

                    collect[field] = true;
                    return collect;
                }, {});

                // Uniquified
                this._sfOpts.fields = Object.keys(this._sfOpts.fieldsMap);

                // Cached proposers
                this._sfProposers = {};

                this.state = this.state || {};

                if (typeof this.props === 'undefined') {
                    throw new Error('You gotta pass props in constructor with super(props) when using strange-forms.');
                }

                // Sync current props to state pre-mount, etc.
                Object.assign(this.state, this._sfStatePatch(this.props));
            }
        }, {
            key: '_sfGet',
            value: function _sfGet(props, field) {

                var getter = this._sfOpts.get;

                if (typeof getter === 'string') {
                    return internals.maybeString(internals.getDeep(props, getter + '.' + field));
                }

                if (getter === null) {
                    return internals.maybeString(props[field]);
                }

                // Object provides per-field getter (string/func)

                if ((typeof getter === 'undefined' ? 'undefined' : _typeof(getter)) === 'object') {
                    getter = getter[field] || getter['*'];
                    if (typeof getter === 'string') {
                        // If using the default, append the field to the getter
                        var usingDefault = !this._sfOpts.get[field];
                        var getterProp = usingDefault ? getter + '.' + field : getter;
                        return internals.maybeString(internals.getDeep(props, getterProp));
                    }
                }

                // If it wasn't a string, it better be a function
                return getter(props, field);
            }
        }, {
            key: '_sfAct',
            value: function _sfAct(field, value) {

                var actor = this._sfOpts.act;

                // Object provides per-field actor (func)

                if ((typeof actor === 'undefined' ? 'undefined' : _typeof(actor)) === 'object') {
                    actor = actor[field] || actor['*'];
                }

                for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                    args[_key - 2] = arguments[_key];
                }

                return actor.apply(undefined, [field, value].concat(args));
            }

            // Sync these props to state

        }, {
            key: '_sfStatePatch',
            value: function _sfStatePatch(props) {
                var _this2 = this;

                return this._sfOpts.fields.reduce(function (collector, field) {

                    var newValue = _this2._sfGet(props, field);
                    var oldValue = _this2._sfGet(_this2.props, field);
                    var curValue = _this2.fieldValue(field);

                    if (newValue !== oldValue || typeof curValue === 'undefined' && typeof newValue !== 'undefined') {
                        collector[internals.prefixed(field)] = newValue;
                    }

                    return collector;
                }, {});
            }
        }, {
            key: '_sfUpdateState',
            value: function _sfUpdateState(props) {

                this.setState(this._sfStatePatch(props));
            }

            // Sync prop to state when prop changes

        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {

                var hasSuperMethod = !!_get(Object.getPrototypeOf(_class.prototype), 'componentWillReceiveProps', this);

                if (hasSuperMethod) {
                    _get(Object.getPrototypeOf(_class.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
                }

                this._sfUpdateState(nextProps);
            }
        }, {
            key: '_sfAssertField',
            value: function _sfAssertField(field) {

                if (!this._sfOpts.fieldsMap[field]) {
                    throw new Error('Field "' + field + '" does not exist in this form.');
                }
            }
        }, {
            key: 'proposeNew',
            value: function proposeNew(field, getValue) {
                var _this3 = this;

                this._sfAssertField(field);

                // Can we use a cached value?  Only when we use the default getFormValue.

                var cacheable = typeof getValue === 'undefined';

                if (cacheable && this._sfProposers[field]) {
                    return this._sfProposers[field];
                }

                // Okay, we couldn't provide a cached function, carry on...

                getValue = getValue || this._sfOpts.getFormValue;

                // Per-field getFormValue

                if ((typeof getValue === 'undefined' ? 'undefined' : _typeof(getValue)) === 'object') {
                    getValue = getValue[field] || getValue['*'];
                }

                var resultFn = function resultFn() {
                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    var value = getValue.apply(undefined, args);

                    var state = {};
                    state[internals.prefixed(field)] = value;
                    _this3.setState(state);

                    _this3._sfAct.apply(_this3, [field, value].concat(args));
                };

                // Cache result if this is cacheable
                if (cacheable) {
                    this._sfProposers[field] = resultFn;
                }

                return resultFn;
            }
        }, {
            key: 'fieldValue',
            value: function fieldValue(field) {

                this._sfAssertField(field);

                return this.state[internals.prefixed(field)];
            }
        }, {
            key: 'fieldError',
            value: function fieldError(field, error) {

                this._sfAssertField(field);

                if (typeof error === 'undefined') {
                    error = true; // Default true
                }

                // Props match state, no error

                var propValue = this._sfGet(this.props, field);
                var stateValue = this.fieldValue(field);

                if (propValue === stateValue) {
                    return null;
                }

                return typeof error === 'function' ? error(stateValue, propValue) : error;
            }
        }]);

        return _class;
    }(superclass);
};

// To be used for field-props of this.state
internals.prefixed = function (field) {
    return '_sf_' + field;
};

// Ex.
// getDeep({ a: { b: null } }, 'a.b') === null
// getDeep({ a: { b: 'c' } }, 'a.b') === 'c'
// getDeep({ a: { b: 'c' } }, 'a.b.c') === undefined
internals.getDeep = function (obj, deepProp) {

    return deepProp.split('.').reduce(function (lastObj, prop) {

        if ((typeof lastObj === 'undefined' ? 'undefined' : _typeof(lastObj)) !== 'object' || lastObj === null) {
            return undefined;
        }

        return lastObj[prop];
    }, obj);
};

internals.defaultGetFormValue = function (e) {
    return e.target.value;
};

internals.maybeString = function (val) {

    if (typeof val === 'undefined' || val === null) {
        return val;
    }

    return String(val);
};


//////////////////
// WEBPACK FOOTER
// ./~/strange-forms/lib/index.js
// module id = 1106
// module chunks = 0